import { Button, ButtonProps, makeStyles } from "@material-ui/core"
import { FC } from "react"
import { colors } from "../../utils/theme"
import PlusIcon from "../atoms/PlusIcon"

const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 50,
    height: 50,
    borderRadius: 25,
    textTransform: "none",
    backgroundColor: colors.primary.ice,
    color: colors.neutral.denim,
    fontWeight: 400,
    "&:hover": {
      backgroundColor: colors.primary.mist,
      boxShadow: "none",
    },
    "&:active": {
      backgroundColor: colors.primary.periwinkle,
      boxShadow: "none",
    },
    "&:disabled": {
      backgroundColor: colors.primary.periwinkle,
      opacity: 0.5,
      cursor: "not-allowed",
      boxShadow: "none",
    },
  },
}))
const AddButton: FC<ButtonProps> = ({ ...props }) => {
  const classes = useStyles()

  return (
    <div className={classes.button}>
      <Button
        onClick={(event) => {
          if (props?.onClick) props?.onClick(event)
        }}
      >
        <PlusIcon />
      </Button>
    </div>
  )
}
export default AddButton
